import { Component } from '@angular/core';

@Component({
  selector: 'app-resume-table',
  templateUrl: './resume-table.component.html',
  styleUrls: ['./resume-table.component.css']
})
export class ResumeTableComponent {

  uid: string;
  tableData;
  resumeData;
  tableItemOver;
  lastClickedWord: any;
  currentItemType: any;
  currentItem: any;
  lastTarget: any;
  origResumeData: any;
  summary: any;
  keyWords: any;

  ngAfterViewInit() {
  }

  displayTable(body: any) {
    this.resumeData = body;
    let color = 'black';
    this.uid = body.uid;
    const tmpTableData = body.result;
    this.summary = '';
    this.keyWords = '';
    this.tableData = []
    for (let item of tmpTableData) {
      if (item.id == 'short_summary') {
        this.summary = item.value;
        
      } else
      if (item.id == 'keywords') {
        this.keyWords = item.value;
      } else {
        this.tableData.push(item);
      }
    }
  }

  unchooseTr() {
    if (!this.tableData) return;
    // for (let item of this.tableData) {
    //   item.chosen = false;
    // }
  }



  itemFocusout() {

  }

  tableItemDown($event, type, item) {
    console.log($event);

    $event.currentTarget.style.backgroundColor = 'yellow';
    if (this.lastTarget && this.lastTarget != $event.currentTarget) {
      this.lastTarget.style.backgroundColor = 'white';
    }
    this.lastTarget = $event.currentTarget;
    this.currentItemType = item[type];
    this.currentItem = item;


  }

  wordClicked(word: any) {
    if (this.lastClickedWord == word) return;
    // console.log(word["description"]);
    this.lastClickedWord = word;
    setTimeout(() => {
      this.lastClickedWord = null;
    }, 1000);
    if (this.currentItemType) {
      this.currentItemType.word.text += ` ${word['description']}`;
    }
  }
  addRow() {
    this.tableData.unshift({
      label: { word: { text: '' } },
      value: { word: { text: '' } },
      chosen: true,
    });
  }
  restart() {
    this.unchooseTr();
    this.tableData = null;
  }
  downloadImg() {
    const imgBase64 =     `data:image/png;base64, ${this.resumeData.imgBase64}`;
    const link = document.createElement('a');
    link.href = imgBase64;
    link.download = 'resume.png';
    link.click();
  }  
}
